import React, { Fragment } from "react";
import { DialogComponent } from "../common/DialogComponent";
import { ICSIDUserStatus } from "../../store/csid/types";
import EZSCreditAuthentication from "../Credit/Auth/EZSCreditAuthentication";
import IDFCreditAuthentication from "../Credit/Auth/IDFCreditAuthentication";

const AlertL3Dialog = (props: {
    showCreditAuth: any;
    csidUserStatus: ICSIDUserStatus;
    closeDisclosureDialogCallBack: any;
    isIDFuser: boolean;
    creditAuthSuccessCallBack: any;
}) => {
    const { showCreditAuth, csidUserStatus, closeDisclosureDialogCallBack, isIDFuser, creditAuthSuccessCallBack } = props;

    return (
        <Fragment>
            {showCreditAuth && csidUserStatus && (
                <DialogComponent dialogId="dialog-l3-disclosure" title="L3 Disclosure" closeDialog={closeDisclosureDialogCallBack} hideCloseButton={false}>
                    <div className="dialog-body">
                        {csidUserStatus.l3AuthProvider.isTU || csidUserStatus.l3AuthProvider.isIDF ? (
                            <IDFCreditAuthentication
                                initCSIDUserStatus={csidUserStatus as ICSIDUserStatus}
                                creditAuthCallback={creditAuthSuccessCallBack}
                                displayFlowAsDialog={false}
                            />
                        ) : (
                            <EZSCreditAuthentication
                                initCSIDUserStatus={csidUserStatus as ICSIDUserStatus}
                                creditAuthCallback={creditAuthSuccessCallBack}
                                displayFlowAsDialog={false}
                                onCloseCallback={closeDisclosureDialogCallBack}
                                l3Case={"credit-service"}
                                componentParent={"dashboard"}
                            />
                        )}
                    </div>
                </DialogComponent>
            )}
        </Fragment>
    );
};

export default AlertL3Dialog;
